export const enum GenericEvents {
	REGISTRY_SHOW = 'registry_show',
	NEWSLETTER_SUBSCRIBE = 'newsletter_subscribe',
	CUSTOMIZE_ACCOUNT_LATER = 'customize_account_later',
	CUSTOMIZE_NEWSLETTER = 'customize_newsletter',
	CUSTOMIZE_ACCOUNT = 'customize_account',
}
